<app-new-search></app-new-search>
<app-equipment-panel> </app-equipment-panel>
<app-resources-panel></app-resources-panel>
<app-chat-panel></app-chat-panel>